var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 45H3.5C2.68 45 2 44.32 2 43.5C2 42.68 2.68 42 3.5 42H43.5C44.32 42 45 42.68 45 43.5C45 44.32 44.32 45 43.5 45Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 45H5.5C4.68 45 4 44.32 4 43.5V11.5C4 5.46 7.46 2 13.5 2H33.5C39.54 2 43 5.46 43 11.5V43.5C43 44.32 42.32 45 41.5 45ZM7 42H40V11.5C40 7.06 37.94 5 33.5 5H13.5C9.06 5 7 7.06 7 11.5V42V42Z",
    fill: "#03182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 45H17.5C16.68 45 16 44.32 16 43.5V31.38C16 29.52 17.52 28 19.38 28H27.64C29.5 28 31.02 29.52 31.02 31.38V43.5C31.02 44.32 30.32 45 29.5 45ZM19 42H28V31.38C28 31.18 27.84 31 27.62 31H19.36C19.16 31 18.98 31.16 18.98 31.38V42H19Z",
    fill: "#03182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23C22.68 23 22 22.32 22 21.5V11.5C22 10.68 22.68 10 23.5 10C24.32 10 25 10.68 25 11.5V21.5C25 22.32 24.32 23 23.5 23Z",
    fill: "#FF2B26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18H18.5C17.68 18 17 17.32 17 16.5C17 15.68 17.68 15 18.5 15H28.5C29.32 15 30 15.68 30 16.5C30 17.32 29.32 18 28.5 18Z",
    fill: "#FF2B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.9cc5f505e5adb3cfa997306abbe50f9a.svg";
export { ForwardRef as ReactComponent };